@if (isOpen()) {
  <div (click)="close()" class="backdrop">
    <div (click)="stopProp($event)" class="modal">

      <button (click)="close()" class="close" aria-label="Zamknij">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      <div class="hero">
        <div class="hero-glow"></div>
        <div class="hero-logo"><span>W</span></div>
        <h2 class="hero-title">Witaj ponownie</h2>
        <p class="hero-sub">Zaloguj się, aby wrócić do swoich quizów.</p>
      </div>

      <div class="body">
        <div class="actions">
          <button (click)="signInWithGoogle()" [disabled]="loading()" class="provider google">
            <svg width="20" height="20" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.4 0 10.3-2.1 14-5.4l-6.5-5.5C29.6 34.7 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.5 5.5C39.3 41.3 44 36 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>
            {{ pending() === 'google' ? 'Logowanie…' : 'Kontynuuj z Google' }}
          </button>
          <button (click)="signInWithFacebook()" [disabled]="loading()" class="provider facebook">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z"/></svg>
            {{ pending() === 'facebook' ? 'Logowanie…' : 'Kontynuuj z Facebookiem' }}
          </button>
          @if (error()) {
            <p class="err">{{ error() }}</p>
          }
        </div>
        <p class="terms">Logując się akceptujesz <span>Regulamin</span> i <span>Politykę prywatności</span>.</p>
      </div>

    </div>
  </div>
}
